import { render, staticRenderFns } from "./copy1.vue?vue&type=template&id=af7c3e58&scoped=true"
import script from "./copy1.vue?vue&type=script&lang=js"
export * from "./copy1.vue?vue&type=script&lang=js"
import style0 from "./copy1.vue?vue&type=style&index=0&id=af7c3e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7c3e58",
  null
  
)

export default component.exports